module.exports = __webpack_public_path__ + "images/section-header-bg.png";